import {Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseAuthService } from 'src/app/services/auth/firebase-auth.service';
import { FirestoreService } from 'src/app/services/common/firestore.service';
import {LocalService} from "../../../services/common/local.service";

@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss'],
})
export class EmployeesComponent implements OnInit, OnDestroy {

  claims;
  employees = [];
  employeesFiltered = [];
  institution: any;
  employeesSub: any;

  constructor(
    private firestoreService: FirestoreService,
    private fireAuthService: FirebaseAuthService,
    private localService: LocalService,
    private router: Router
  ) { }

  ngOnInit() {
    this.fireAuthService.currentUser.getIdTokenResult().then((result) => {
      this.institution = result.claims.institution;
      this.getEmployees();
    });
  }

  ngOnDestroy() {
    if (this.employeesSub) {
      this.employeesSub.unsubscribe();
    }
  }

  getEmployees() {
    const queryArray = [];
    const query = {
      field: 'institution',
      operator: '==',
      value: this.institution
    };
    queryArray.push(query);
    this.employeesSub = this.firestoreService.getAllBy('users', queryArray, 'lastName', 'asc')
      .subscribe((usersSnapshot) => {
        const employees = [];
        usersSnapshot.forEach((userSnapshot) => {
          const employee: any = userSnapshot.payload.doc.data();
          employee.id = userSnapshot.payload.doc.id;
          employee.fullName = employee.lastName + ', ' + employee.firstName;
          employees.push(employee);
        });
        this.employees = employees;
        this.employeesFiltered = employees;
      });
  }

  addEmployee() {
    this.router.navigateByUrl('/admin/employees/create');
  }

  viewEmployee(id: string) {
    this.router.navigateByUrl('/admin/employees/' + id);
  }

  onEmployeeSearch(event: any) {
    const searchValue = event.detail.value
    if (searchValue.length > 0) {
      this.employeesFiltered = this.employees.filter(employee => employee.fullName.toLowerCase().includes(searchValue.toLowerCase()));
    } else {
      this.employeesFiltered = this.employees;
    }
  }

}
